document.addEventListener('DOMContentLoaded', function () {
  function adjustBlockSwatchFlex() {
    const containers = document.querySelectorAll('.variant-picker__option-values');

    containers.forEach(container => {
      const blocks = Array.from(container.querySelectorAll('.block-swatch'));

      const hasMultiLine = blocks.some(block => {
        const span = block.querySelector('span');
        if (!span) return false;

        const lineHeight = parseFloat(getComputedStyle(span).lineHeight);
        const lines = Math.round(span.scrollHeight / lineHeight);

        console.log(lines);
        return lines > 1;
      });

      container.classList.toggle('is-full-width', hasMultiLine);
    });
  }

  adjustBlockSwatchFlex();

  setTimeout(function() {
      const ReviewElements = document.querySelectorAll('.wc_review_item_body_desc');

      ReviewElements.forEach(ReviewElement => {
          const wrapper = document.createElement('div');
          wrapper.classList.add('icon-heading');
          const parentElement = ReviewElement.parentNode;
          parentElement.insertBefore(wrapper, ReviewElement);
          wrapper.appendChild(ReviewElement);
      });
  }, 3000);


});

